import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BookingApi } from '@/api';
import { DataGrid } from '@/components';
import { useDataGridColumns } from '@/components/DataGrid/hooks/useDataGridCols';
import {
  DataGridColSettings,
  mergeColumnSettings,
} from '@/components/DataGrid/utils';
import { Button } from '@/components/TailwindComponents';
import { LocalStoragePrefix } from '@/constants';
import { bookingDataGridColumns } from '@/pages/JMS/Managament/data/data';
import { JmsManagementRoutes } from '@/pages/JMS/Managament/utils/utils';
import { useBookingStore } from '@/pages/JMS/store/BookingStore';
import { useUserStore } from '@/store';
import { getLocalStorageItem } from '@/utils';

export const BookingDataGrid = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const { clearBooking } = useBookingStore();

  const fetchInmates = async (
    page = 1,
    limit = 10,
    filter?: string,
    sort = '',
  ) => {
    try {
      const response = await BookingApi.list({
        page,
        limit,
        filter,
        sort,
      });

      return {
        rows: response.data.docs,
        totalCount: response.data.totalDocs,
      };
    } catch (error) {
      return {
        rows: [],
        totalCount: 0,
      };
    }
  };

  const [columnSettings, setColumnSettings] = useState<DataGridColSettings[]>(
    () => {
      const savedSettings = getLocalStorageItem({
        key: String(user?._id),
        prefix: `inmate-bookings-${LocalStoragePrefix.TableSetting}`,
        shouldParse: true,
      });

      if (!savedSettings) {
        return bookingDataGridColumns;
      }

      return mergeColumnSettings(bookingDataGridColumns, savedSettings);
    },
  );

  const handleView = (bookingId: string) => {
    navigate(JmsManagementRoutes.ViewBooking(bookingId));
  };

  const handleEdit = (bookingId: string) => {
    navigate(JmsManagementRoutes.EditBooking(bookingId));
  };

  const columns = useDataGridColumns({
    type: 'inmateBooking',
    columnSettings,
    onView: handleView,
    onEdit: handleEdit,
  });

  const cta = (
    <Button
      className="h-[38px]"
      onClick={() => {
        navigate(JmsManagementRoutes.SearchPerson);
        clearBooking();
      }}
    >
      Add New Booking
    </Button>
  );

  return (
    <DataGrid
      name="inmate-bookings"
      columns={columns}
      columnSettings={columnSettings}
      setColumnSettings={setColumnSettings}
      fetchData={fetchInmates}
      cta={cta}
    />
  );
};
